module.exports = __webpack_public_path__ + "static/img/shui-1.5b3ced7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shui-1.png
// module id = IDDg
// module chunks = 0